export const defaultQueryOptions = {
  gcTime: 24 * 60 * 60 * 1000,
  retry: false,
  staleTime: 5 * 60 * 1000,
  throwOnError: true,
} as const;
